import fetch from '@/plugin/axios'

// 获取智能体 行业列表
export function getAgentIndustryList (data) {
  return fetch({
    url: '/api/order/agent-industry/pageList',
    method: 'Post',
    data: data
  })
}

// 添加行业
export function addAgentIndustry (data) {
  return fetch({
    url: '/api/order/agent-industry/add',
    method: 'Post',
    data: data
  })
}

// 修改行业
export function updateAgentIndustry (id, data) {
  return fetch({
    url: `/api/order/agent-industry/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 获取行业详情
export function getAgentIndustryDetail (id) {
  return fetch({
    url: `/api/order/agent-industry/info/${id}`,
    method: 'Get'
  })
}

// 添加分配智能体训练数据
export function addAgentAllocateData (data) {
  return fetch({
    url: '/api/order/agent-allocate-data/add',
    method: 'Post',
    data: data
  })
}

// 获取分配智能体训练数据
export function getAgentAllocateData (data) {
  return fetch({
    url: '/api/order/agent-allocate-data/pageList',
    method: 'Post',
    data: data
  })
}

// 获取分配智能体训练数据详情
export function getAgentAllocateDataDetail (id) {
  return fetch({
    url: `/api/order/agent-allocate-data/info/${id}`,
    method: 'Get'
  })
}

// 删除分配智能体训练数据
export function deleteAgentAllocateData (id) {
  return fetch({
    url: `/api/order/agent-allocate-data/${id}`,
    method: 'Delete'
  })
}

// 修改分配智能体训练数据
export function updateAgentAllocateData (id, data) {
  return fetch({
    url: `/api/order/agent-allocate-data/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 生成需求
export function generateDemand (id) {
  return fetch({
    url: `/api/order/agent-allocate-data/auto-demand/${id}`,
    method: 'Get'
  })
}

// 分解任务
export function decomposeTask (id, data) {
  return fetch({
    url: `/api/order/agent-allocate-data/auto-task/${id}`,
    method: 'Post',
    data: data
  })
}
// 分析需求
export function analyzeDemand (demand) {
  return fetch({
    url: `/api/order/agent-allocate-data/auto-proj-by-description`,
    method: 'Post',
    data: {
      description: demand
    }
  })
}

// 获取行业选项
export function getIndustryOptions () {
  return fetch({
    url: '/api/order/agent-industry/options',
    method: 'Get'
  })
}

// 获取行业岗位信息
export function getIndustryPostList (id) {
  return fetch({
    url: `/api/order/agent-industry-post/posts/${id}`,
    method: 'Get'
  })
}

// 获取智能体列表
export function getAgentList (data) {
  return fetch({
    url: '/api/common/ai-agent/list',
    method: 'Post',
    data: data
  })
}

// 获取智能体详情
export function getAgentDetail (id) {
  return fetch({
    url: `/api/common/ai-agent/info/${id}`,
    method: 'Get'
  })
}

// 删除智能体
export function deleteAgent (id) {
  return fetch({
    url: `/api/common/ai-agent/${id}`,
    method: 'Delete'
  })
}

// 修改智能体
export function updateAgent (id, data) {
  return fetch({
    url: `/api/common/ai-agent/update/${id}`,
    method: 'Post',
    data: data
  })
}

export function addAgent (data) {
  return fetch({
    url: '/api/common/ai-agent/add',
    method: 'Post',
    data: data
  })
}

export function agentOptions () {
  return fetch({
    url: '/api/common/ai-agent/options',
    method: 'Get'
  })
}

// 测试智能体
export function runAgent (id, data) {
  return fetch({
    url: `/api/common/ai-agent/run/${id}`,
    method: 'Post',
    data: data
  })
}

// 获取智能体执行结果
export function getAgentRunResult (workflowId, executeId) {
  return fetch({
    url: `/api/common/ai-agent/run/${workflowId}/${executeId}`,
    method: 'Get'
  })
}
